import axios from "axios";
import router from "@/router/index";
import { Notification } from "element-ui";

const http = axios.create({
  timeout: 100000,
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'application/json;charset=utf-8'}
});

// 添加请求拦截器
http.interceptors.request.use(
  config => {
    if (localStorage.token) config.headers.Authorization = `Bearer ${localStorage.token}`;
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  response => {
    switch (response.data.code) {
      case "0":
      case 0:
        break;

      case "-100":
        break;

      case "-5":
        localStorage.clear();
        router.push({
          path: "/login"
        });
        break;

      default:
        Notification.error({ title: "请求错误", message: response.data.message });
        break;
    }

    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

export default http;
